import requestHandler from 'shared/utils/request-handler';
import { ISocialResponse } from './social.dto';

const BASE_URL = '/api/v1/Social';

export const GETSocial = async () => {
	return requestHandler.call<ISocialResponse[]>({ url: `${BASE_URL}`, method: 'get' }).then(res => res.data);
};
